import { useState } from "react";
import { AddressHelper } from "../utils/helpers";
import { toast } from "react-toastify";

/**
 * useCEP
 * Hook para gerenciar a busca de endereços automática por CEP. 
 * Pode ser usado em formulários de clientes, unidades, funcionários, etc.
 */
export const useCEP = () => {
    const [loading, setLoading] = useState(false);
    const [address, setAddress] = useState(null);

    const searchCEP = async (cep) => {
        const cleanCep = cep?.replace(/\D/g, "");

        // Se o CEP for inválido, apenas retorna
        if (!cleanCep || cleanCep.length !== 8) {
            setAddress(null);
            return null;
        }

        setLoading(true);
        try {
            const data = await AddressHelper.fetchByCep(cleanCep);
            setAddress(data);
            return data;
        } catch (error) {
            setAddress(null);
            toast.error("CEP não encontrado ou erro na busca.");
            return null;
        } finally {
            setLoading(false);
        }
    };

    const clearAddress = () => setAddress(null);

    return {
        loading,
        address,
        searchCEP,
        clearAddress
    };
};
